import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Stepper from '../stepper/stepper';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Title from '../common/custom-components/customTitleHeader';

const SuccessInfoForm = () => {
  return (
    <div className="container page">
      <Stepper activeStep={3} />
      <div className="row" style={{ backgroundColor: '#F7F8F9' }}>
        <div className="col-md-6 offset-md-3 col-xs-12">
          <Card boxShadow={3}>
            <CardContent>
              <div>
                <Title text="Application Confirmation" />
              </div>
              <div className="headerAlign">
                <Typography
                  className="title-h5"
                  gutterBottom
                  variant="h5"
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  className="text-xs-center"
                >
                  Your application was successfully submitted.
                </Typography>
                <Typography
                  display="block"
                  gutterBottom
                  variant="subtitle1"
                  paragraph={true}
                >
                  You will receive an email confirmation, along with next steps,
                  to the address provided when you registered for your account.
                </Typography>
                <div className="text-xs-center">
                  <Link to="/home" align="center">
                    Go to Home Page
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
export default SuccessInfoForm;
